import type { SavedTargetingsManager } from '@/state/experiments/useSavedTargetings';
import { Bookmark } from 'lucide-react';

type TargetingSourceLineProps = { manager: SavedTargetingsManager };

/** "Loaded from X", plus "Edited since load" once the rules no longer match what was loaded. */
export const TargetingSourceLine = ({ manager }: TargetingSourceLineProps) => {
  const { source, editedSinceLoad } = manager;
  if (!source) return null;

  return (
    <p className="supporting mt-1.5 flex flex-wrap items-center gap-2">
      <Bookmark className="size-3.5 shrink-0" strokeWidth={1.5} aria-hidden="true" />
      <span>
        Loaded from <strong className="text-foreground font-medium">{source.name}</strong>
      </span>
      {editedSinceLoad ? (
        <span className="border-warn-line bg-warn-bg text-warn inline-flex items-center gap-1.5 rounded-pill border px-2 py-0.5 text-micro">
          <span className="bg-warn size-1.5 rounded-full" aria-hidden="true" />
          Edited since load
        </span>
      ) : null}
    </p>
  );
};
